import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3102136"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "card-box" }
const _hoisted_3 = { class: "project-title" }
const _hoisted_4 = { class: "grey" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "合同编号", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = { class: "black" }
const _hoisted_8 = { class: "grey" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "合同金额", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = { class: "black" }
const _hoisted_12 = { class: "grey" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "质保期限", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode()
const _hoisted_15 = { class: "black" }
const _hoisted_16 = { class: "grey" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "质保金额", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = { class: "black" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip grey" }, "合同列表", -1))
const _hoisted_21 = {
  key: 0,
  class: "layout-list"
}
const _hoisted_22 = { class: "row row-layout-box" }
const _hoisted_23 = { class: "left-box" }
const _hoisted_24 = { class: "row between" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black title" }, "合同上传", -1))
const _hoisted_26 = { class: "grey" }
const _hoisted_27 = { class: "grey" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 合同金额 ")
const _hoisted_29 = { class: "black" }
const _hoisted_30 = { class: "left-box" }
const _hoisted_31 = { class: "row between" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black title" }, "补充协议", -1))
const _hoisted_33 = { class: "grey" }
const _hoisted_34 = { class: "grey" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 合同金额 ")
const _hoisted_36 = { class: "black" }
const _hoisted_37 = { key: 1 }

import { onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getContractList } from '@/apis/projectDetail'
import { ProjectData } from '@/apis/projectList'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const project_id = ref(0)
const projectDetail = ref({} as ProjectData)
const state = reactive({
  contractList: {
    staff_job: '产品设计师',
    staff_name: '冯海霞',
    shelf_life: '5年',
    shelf_life_money: 6000,
    initial_money: 2000000,
    money: 2000000,
    number: 'dgfg',
    other_promise: '',
    payment_promise: '要按期完成',
    company: '襄阳中学',
    created_at: '2022-05-29 15:59:29',
    delivery_date: '2024-05-29',
    finish_date: '2024-05-29',
    agreements: [
      {
        cf_name: '',
        contract_id: 20,
        created_at: '2022-05-29 16:01:56',
        deleted_at: '',
        explain: '后续运营费用',
        id: 12,
        job_name: '职务',
        money: 10000,
        number: 'dgfg',
        other_promise: '',
        payment_promise: '要按期完成',
        pics: 'https://img.hbzgyc.com/minio/deyi-oa/oa-sales/2022/05/20220529-629327d80c7ef.jpg',
        project_id: 32,
        shelf_life: '5年',
        shelf_life_money: 6000
      }
    ]
  }
})

const get_agreement_List = async () => {
  const res = await getContractList({ project_id: project_id.value })
  if (res.code === 200) {
    state.contractList = res.data
  }
}

onMounted(() => {
  let data = JSON.parse(localStorage.getItem('PROJECT_DETAIL'))
  projectDetail.value = data
  project_id.value = Number(router.currentRoute.value.query.project_id)
  get_agreement_List()
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(projectDetail.value.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(state).contractList.number || '无'), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(state).contractList.money) + "元", 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(state).contractList.shelf_life || '暂无'), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _hoisted_18,
        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(state).contractList.shelf_life_money) + "元", 1)
      ])
    ]),
    _hoisted_20,
    (_unref(state).contractList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(state).contractList.created_at), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(state).contractList.initial_money) + "元", 1)
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).contractList.agreements, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row row-layout-box",
              key: index
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, _toDisplayString(item.created_at), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("span", _hoisted_36, _toDisplayString(item.money) + "元", 1)
                ])
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createVNode(_component_van_empty, {
            image: "search",
            description: "暂无数据"
          })
        ]))
  ]))
}
}

})